import React from 'react';
import { Chat42Error } from '@/core/error';
import { checkPermission } from '@/util/permissionUtil';
import { usePermissions } from '@/query/permission';
import { useAgentId } from '@/hook';


interface AgentContentLayoutProps {
    label: string;
    permissions?: readonly string[];
    children: React.ReactNode;
}

const AgentContentLayout: React.FC<AgentContentLayoutProps> = (props) => {
    const { label, children, permissions: viewPermissions } = props;

    const agentId = useAgentId();

    const { data: userPermissions } = usePermissions(agentId);

    if (!userPermissions) {
        return null;
    }
    if (!checkPermission(userPermissions, viewPermissions ?? [])) {
        throw new Chat42Error('403');
    }
    return (
        <div className="flex-1 min-w-0 h-full flex flex-col">
            <div className="relative flex-none w-full h-[72px]">
                <div className="agent-header absolute left-[-250px] z-10" />
                <div className="absolute size-full pl-5 flex justify-start items-center z-20 text-white text-[18px] font-[400]">
                    {label}
                </div>
            </div>
            {children}
        </div>
    );
};

export default AgentContentLayout;
